import { z } from "zod";

import {
  SMS_OPT_OUT_SOURCE,
  SMS_PERFORMANCE_SORT_KEYS,
  SMS_STATUS,
  SMS_TREND_METRIC_KEYS,
} from "@/constants/sms-analytics";

export const smsTrendMetricSchema = z.enum(SMS_TREND_METRIC_KEYS);

const smsPerformanceSortKeySchema = z.enum(SMS_PERFORMANCE_SORT_KEYS);

export const smsPerformanceSortSchema = z.union([
  smsPerformanceSortKeySchema,
  z.templateLiteral(["-", smsPerformanceSortKeySchema]),
]);

const smsOptOutSourceSchema = z.nativeEnum(SMS_OPT_OUT_SOURCE);

const rateSchema = z.number().nullable();

export const smsCountsSchema = z.object({
  sent: z.number(),
  failed: z.number(),
  linkSms: z.number(),
  clickedSms: z.number(),
  totalClicks: z.number(),
  failedRate: rateSchema,
  clickRate: rateSchema,
});

export const smsPerformanceCountsSchema = smsCountsSchema.extend({
  stops: z.number(),
});

export const smsStatusSchema = z.object({
  everSubscribed: z.number(),
  subscribed: z.number(),
  subscribedRate: rateSchema,
  unsubscribed: z.number(),
  unsubscribedRate: rateSchema,
  viaSms: z.number(),
  viaApp: z.number(),
  viaAdmin: z.number(),
  failed: z.number(),
  attempts: z.number(),
  failedRate: rateSchema,
});

export const smsStatusResponseSchema = z.object({
  data: smsStatusSchema,
});

export const unsubscribedPatientSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  source: smsOptOutSourceSchema,
  optedOutAt: z.string().nullable(),
  lastSmsType: z.string().nullable(),
});

export const unsubscribedPatientsResponseSchema = z.object({
  data: z.array(unsubscribedPatientSchema),
});

export const smsTrendPointSchema = smsCountsSchema.extend({
  periodStart: z.string(),
});

export const smsTrendsResponseSchema = z.object({
  data: z.array(smsTrendPointSchema),
  totals: smsCountsSchema,
  previousTotals: smsCountsSchema,
});

export const smsTypePerformanceSchema = smsPerformanceCountsSchema.extend({
  smsType: z.string(),
  linkExpected: z.boolean(),
});

export const smsPerformanceResponseSchema = z.object({
  data: z.array(smsTypePerformanceSchema),
  totals: smsPerformanceCountsSchema,
});

export const smsOptOutSchema = z.object({
  source: smsOptOutSourceSchema,
  optedOutAt: z.string().nullable(),
  smsType: z.string().nullable(),
});

export const profileSmsSchema = z.object({
  id: z.number(),
  smsType: z.string(),
  linkExpected: z.boolean(),
  createdAt: z.string(),
  sentAt: z.string().nullable(),
  status: z.nativeEnum(SMS_STATUS),
  hasLink: z.boolean(),
  clicks: z.number(),
  lastClickedAt: z.string().nullable(),
  repliedStop: z.boolean(),
});

export const profileSmsResponseSchema = z.object({
  data: z.array(profileSmsSchema),
  totals: smsCountsSchema,
  optOut: smsOptOutSchema.nullable(),
});
